import { Dialog } from "@mui/material";
import React from "react";
// import NexFamily from "../../assets/images/nex-family-green.png";
import NexFamily from "../../assets/images/nex-family.png";
import SecondaryGreenButton from "../button/SecondaryGreenButton";

export default function PopupRegisterCatSuccess(props) {
  const { onClose, selectedValue, open } = props;

  const handleClose = () => {
    onClose(selectedValue);
  };

  const handleListItemClick = (value) => {
    onClose(value);
  };

  return (
    <Dialog onClose={handleClose} open={open}>
      <div className="pb-[36px] pt-[24px] px-[23px] rounded-[4px]">
        <p className="text-lightGreen text-[28px] text-center">
          ยินดีที่คุณเข้ามาเป็นส่วนหนึ่งของ
        </p>
        <p className="text-lightGreen text-[32px] text-center">
          ครอบครัว
          <img
            src={NexFamily}
            alt="One And Done"
            style={{
              height: "25px",
              display: "inline-block",
              marginLeft: "10px",
            }}
          ></img>
        </p>
        <p className="text-[24px] text-center">
          คุณได้รับ Coin จากการสมัครสมาชิก
        </p>
        <p className="text-lightGreen text-[42px] text-center">
          {props.point} คะแนน
        </p>
        <div className="flex itesm-center gap-[13px] justify-center mt-[24px]">
          <SecondaryGreenButton
            variant="outlined"
            className="w-[50%]"
            onClick={() => props.actionFunction()}
          >
            ปิด
          </SecondaryGreenButton>
        </div>
      </div>
    </Dialog>
  );
}
